import { Validator } from '@vista-digital/validator';
import { SeatPickerScreenPosition, seatPickerScreenPositionValidator } from './screen-position';
export const defaultSeatPickerScreenConfig = {
    height: 35,
    margin: 10,
    bevelOffset: 30,
    position: SeatPickerScreenPosition.Top
};
export const seatPickerScreenConfigValidator = Validator.object({
    height: Validator.number({ min: 0 }),
    margin: Validator.number({ min: 0 }),
    bevelOffset: Validator.number({ min: 0 }),
    position: seatPickerScreenPositionValidator
});
